import qs from "query-string";

function checkStatus(response: Response): Response {
	if (!response.ok || response.status !== 200) {
		console.error("error:", response);
		return;
	}
	return response;
}

interface Options {
	apiDomain?: string;
	cookie?: string;
	headers?: { [key: string]: any };
	fetchMethod?: "GET" | "POST";
}

function webapi<T>(
	method: string,
	params: any,
	{ apiDomain, cookie, headers, fetchMethod = "POST" }: Options = {},
): Promise<T> {
	const isProtobufMethod = method.includes("/");
	const webapiAddress = apiDomain;

	let url = `${webapiAddress}/${isProtobufMethod ? method : method.replace(/\./g, "/")}`;
	url = method ? url : `${apiDomain}${method}`;

	let init: RequestInit = {
		method: fetchMethod,
		headers: {
			cookie,
			...headers,
		},
	};
	if (fetchMethod.toLocaleUpperCase() === "GET") {
		url = `${url}?${qs.stringify(params)}`;
	}
	if (fetchMethod.toLocaleUpperCase() === "POST") {
		init = {
			...init,
			credentials: "include",
			body: JSON.stringify(params),
		};
	}
	if (__SERVER__) {
		const { statsDClient, AppLogger } = require("ez-node-monitor");
		AppLogger.info(`[fetch] ${url} - ${JSON.stringify(params)}`);
		const startTime = Date.now();
		return fetch(url, init)
			.then(checkStatus)
			.then((response) => {
				if (response) {
					statsDClient.statsd_api_timing(method, startTime);
					return response.json() as Promise<T>;
				}
			})
			.catch((err) => {
				statsDClient.statsd_api_failure(method);
				throw err;
			});
	}

	return fetch(url, init)
		.then(checkStatus)
		.then((response) => response.json() as Promise<T>)
		.catch((err) => {
			throw err;
		});
}

interface fileFetchOptions {
	url: string;
	params?: any;
}
export function fileFetch(props: fileFetchOptions): Promise<any> {
	const { url, params } = props;
	const init: RequestInit = {
		method: "GET",
		body: params ? JSON.stringify(params) : null,
	};
	return fetch(url, init)
		.then(checkStatus)
		.then((response) => response?.json() as Promise<any>);
}

export default webapi;
